/**
 * 所有接口变量都以 api开头，例如：apiGetUserInfo
 */

 import { apiPost, apiGet } from 'utils'
 import { DropdownBox, XhhyBaseVO, XhhyRequest } from 'Xhhy-common/common'
 
 /**
  * 查询角色下拉框
  * @param params
  */
  export const apiSelectUser = async (params: XhhyRequest) => {
    return await apiPost<XhhyRequest, Array<DropdownBox>>(`/apppocapi/role/combox`, params)
  }

 